(ns shared.core.error
  (:require [shared.core.style :as style]
            [shared.core.components.theme :as theme]))

(defn error-message [{:keys [style]} & contents]
  (into [theme/theme
         :div {:style (merge {:color (style/color :red :error)
                              :font-size 14
                              :font-weight style/font-medium-weight
                              :text-align :center}
                             style)
               :theme (style/dark-style {:color (style/dark-color :secondary :base)})}]
        contents))

(defn error-messages [{:keys [errors style message-style]}]
  (into [:div {:style (merge {:display :flex
                              :flex-direction :column}
                             style)}]
        (map-indexed (fn [idx {:keys [message]}]
                       [error-message {:style (merge (when (not= idx 0)
                                                       {:margin-top 10})
                                                     message-style)}
                        message])
                     errors)))
